import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress, Container, Stack, Avatar, Skeleton, Radio, RadioGroup } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { AmyPorterfield, clientPointWhite, dolbyWhite, ewLogo, fb, foundrWhite, keapWhite, linkdin, Logo, LogoDarkMode, mail, microsoft, dayTrialCloud, susieMoore, teachableWhite, } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon, MicrosoftIcon, RightArrow, TickSymbolThin } from '../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import umbrellaSignBg from "../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AccountVerification from '../modals/AccountVerification'
import moment from 'moment-timezone';
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { Applications } from '../types/enums'
import { toast } from 'react-toastify'
import { SocialProvider } from '../types/auth'
import { config } from '../config'
import theme from '../theme'
import { LIVE_PRICES, AUTOMATED_PRICES, LIVE_AUTO_PRICES, PricingTier } from '../components/subscription/pricing/pricingData';
import { formatPlanName, validateEmail, generateSecurePassword } from '../utils/common.util'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'
import { PLAN_NAMES } from '../constants/planNames'
import { ArrowForward, ArrowBack, People } from '@mui/icons-material'
import EventsLoggerService from '../services/events-logger.service'
import { 
    SIGNUP_FLOWS,
    logEvent,
    EVENT_TYPES,
    SIGNUP_STEPS
} from '../utils/events.util'
import PasswordStrengthIndicator from '../components/common/PasswordStrengthIndicator'


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Plan configuration for Sale
interface PlanConfig {
    planId: string;
    planName: string;
    price: number;
    InstallmentPrice: number;
    attendees: string; // e.g., "200 Live + 1,000 Automated"
    features: string[];
    savingsBreakdown: {
        regularPrice: string;
        lifetimeDeal: string;
        savingsPercentage: string;
        monthlyEquivalent: string;
        note?: string;
    };
    upgradeText?: string; // Text for upgrade section
}

const PLAN_CONFIGS: Record<string, PlanConfig> = {
    'All-In-One-USD-Every-15-years-200': {
        planId: 'All-In-One-USD-Every-15-years-200',
        planName: 'Professional',
        price: 2399, // Lifetime price
        InstallmentPrice: 2499,
        attendees: '200 Live + 1,000 Automated',
        features: [
            'EasySuite CRM (brand-new inbuilt sales CRM — no integrations needed)',
            'Community and monthly workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$116/month (≈ $1,392/year)',
            lifetimeDeal: '$2,399 one-time',
            savingsPercentage: 'Based on 8-year use, you save ~79% vs. paying annually',
            monthlyEquivalent: '$24.99/month over 8 years'
        },
        //upgradeText: 'Upgrade to Professional Plus — just $492 more for 500 live / 2,500 automated attendees + AI Webinar Builder & Paid Webinars (beta).'
    },
    'All-In-One-USD-Every-15-years-500': {
        planId: 'All-In-One-USD-Every-15-years-500',
        planName: 'Professional Plus',
        price: 3995, // Lifetime price
        InstallmentPrice: 4095,
        attendees: '500 Live + 2,500 Automated',
        features: [
            'EasySuite CRM (brand-new inbuilt sales CRM — no integrations needed)',
            'AI Webinar Builder (beta)',
            'Paid Webinars (beta)',
            'Community and monthly workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$198/month (≈ $2,376/year)',
            lifetimeDeal: '$3,995 one-time',
            savingsPercentage: 'Based on 8-year use, you save ~79% vs. paying annually',
            monthlyEquivalent: '$41.60/month over 8 years'
        }
    },
    'Automated-Gold-USD-Every-15-years-6000': {
        planId: 'Automated-Gold-USD-Every-15-years-6000',
        planName: 'Scale',
        price: 4999, // Lifetime price
        InstallmentPrice: 5100,
        attendees: '6,000 Automated (Simulive and Evergreen)',
        features: [
            'EasySuite CRM (your inbuilt sales CRM)',
            'AI Webinar Builder (beta)',
            'Paid Webinars (beta)',
            'Community and workshop access',
            'Complete webinar funnel setup (worth $1,000)',
            'Priority onboarding & support'
        ],
        savingsBreakdown: {
            regularPrice: '$242/month (≈ $2,904/year)',
            lifetimeDeal: '$4,999 one-time',
            savingsPercentage: 'Based on 8-year use, you save ~79% vs. paying annually',
            monthlyEquivalent: '$52.07/month over 8 years'
        }
    }
};

const WorkshopBundleLifetime = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPromoField, setShowPromoField] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [leadSquaredId, setLeadSquaredId] = useState<string>('');
    const [cards] = useState([
        {
            name: "Amy Porterfield",
            title: "Online Marketing Expert",
            testimonial: `"I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!"`,
            avatar: "https://www.amyporterfield.com/wp-content/uploads/2022/12/Amy-Porterfield-Headshot-Course-Creator-2-2-scaled.jpg"
        }
    ]);

    const getTimezoneString = () => {
        const timezone = moment.tz.guess() || "UTC";
        const offset = moment.tz(timezone).format("Z");
        const zoneName = moment.tz(timezone).zoneName();
        return `(GMT${offset}),${timezone},${zoneName}`;
    };

    const generateFirstName = (email: string) => {
        const emailParts = email.split("@")[0];
        const name = emailParts
            .split(/[._-]/)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(" ");
        return name;
    };

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        timezone: getTimezoneString(),
        subdomain: ''
    });

    // Auto-generate strong password on component mount
    useEffect(() => {
        const autoGeneratedPassword = generateSecurePassword();
        setFormData(prev => ({
            ...prev,
            password: autoGeneratedPassword
        }));
    }, []);
    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
        subdomain: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isAutoRegistering, setIsAutoRegistering] = useState(false);
    const [isCardReady, setIsCardReady] = useState(false);
    const [isCardValid, setIsCardValid] = useState(false);

    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });

    const [cardToken, setCardToken] = useState<string>("");
    const [cardError, setCardError] = useState<string | null>(null);
    const cardRef = useRef<any>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const [planDetails, setPlanDetails] = useState<any>(null);
    const [isLoadingPlan, setIsLoadingPlan] = useState(false);
    const [isTrial, setIsTrial] = useState(false);
    const [noTrial, setNoTrial] = useState(true);
    const [monthlyPlanDetails, setMonthlyPlanDetails] = useState<any>(null);
    const [initialPlanId, setInitialPlanId] = useState<string | null>(null);

    const [promoCode, setPromoCode] = useState('');
    const [appliedPromo, setAppliedPromo] = useState<{
        code: string;
        discount: number;
        type: string;
    } | null>(null);
    const [promoError, setPromoError] = useState('');

    const [domainSuggestions, setDomainSuggestions] = useState<string[]>([]);
    const [currentPlanConfig, setCurrentPlanConfig] = useState<PlanConfig | null>(null);
    
    // Initialize paymentOption from URL parameter
    const initializePaymentOption = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('instalment') === 'true' ? 'installments' : 'pay-in-full';
    };
    
    const [paymentOption, setPaymentOption] = useState<'pay-in-full' | 'installments'>(initializePaymentOption());

    // Allowed planIds
    const ALLOWED_PLAN_IDS = [
        'All-In-One-USD-Every-15-years-200',
        'All-In-One-USD-Every-15-years-500',
        'Automated-Gold-USD-Every-15-years-6000'
    ];
    const DEFAULT_PLAN_ID = 'All-In-One-USD-Every-15-years-500';

    const planIdParam = searchParams.get('planId');
    
    // Validate and set default planId if needed
    useEffect(() => {
        if (!planIdParam || !ALLOWED_PLAN_IDS.includes(planIdParam)) {
            setSearchParams((prev) => {
                prev.set("planId", DEFAULT_PLAN_ID);
                return prev;
            }, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planIdParam]);

    // Use validated planId or default
    const planId = planIdParam && ALLOWED_PLAN_IDS.includes(planIdParam) ? planIdParam : DEFAULT_PLAN_ID;
    const cleanPlanId = planId ? planId.replace(/-\d+$/, '') : undefined;

    // Helper function to get base planId for API requests (without the number)
    const getBasePlanId = () => {
        // Remove the number at the end to get base planId (e.g., "All-In-One-USD-Yearly-200" -> "All-In-One-USD-Yearly")
        return planId.replace(/-\d+$/, '');
    };

    // Helper function to get planUnits from planId
    const getPlanUnits = () => {
        const match = planId.match(/-(\d+)$/);
        return match ? parseInt(match[1], 10) : 200;
    };

    // Helper function to get installment planId based on plan name
    const getInstallmentPlanId = () => {
        if (!currentPlanConfig) return '';
        
        const planName = currentPlanConfig.planName;
        switch (planName) {
            case 'Professional':
                return 'All-In-One-USD-Monthly';
            case 'Professional Plus':
                return 'All-In-One-USD-Monthly';
            case 'Scale':
                return 'Automated-Gold-USD-Monthly';
            default:
                return '';
        }
    };

    // Initialize billing period from URL
    const initializeBillingPeriodFromUrl = () => {
        if (cleanPlanId) {
            return cleanPlanId.includes("Yearly");
        }
        return true; // Default to yearly
    };

    const [isYearly, setIsYearly] = useState(initializeBillingPeriodFromUrl());

    // Update plan in URL when billing period changes
    const updatePlanInUrl = (newIsYearly: boolean) => {
        if (!planId) return;

        // Extract the attendee number from the current planId
        const attendeeMatch = planId.match(/-(\d+)$/);
        const attendeeNumber = attendeeMatch ? attendeeMatch[1] : '250'; // Default to 250 if no number found

        // Extract the base plan ID without period and attendee number
        const basePlanId = planId.replace(/(Monthly|Yearly)/g, "").replace(/-\d+$/, "");
        const period = newIsYearly ? "Yearly" : "Monthly";
        const newPlanId = `${basePlanId}${period}-${attendeeNumber}`;

        setSearchParams((prev) => {
            prev.set("planId", newPlanId);
            return prev;
        }, { replace: true });
    };

    const handleBillingPeriodChange = (newIsYearly: boolean) => {
        // If the user clicks on the already selected option, do nothing
        if (isYearly === newIsYearly) {
            return;
        }

        setIsYearly(newIsYearly);
        updatePlanInUrl(newIsYearly);

        // Swap the plan details without making API calls
        if (planDetails && monthlyPlanDetails) {
            if (newIsYearly) {
                // Switching to yearly: set planDetails to yearly, monthlyPlanDetails to monthly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains yearly data
                setMonthlyPlanDetails(planDetails); // planDetails contains monthly data
            } else {
                // Switching to monthly: set planDetails to monthly, monthlyPlanDetails to yearly
                setPlanDetails(monthlyPlanDetails); // monthlyPlanDetails contains monthly data
                setMonthlyPlanDetails(planDetails); // planDetails contains yearly data
            }
        }
    };

    const handleUpgradeClick = () => {
        setSearchParams((prev) => {
            prev.set("planId", "All-In-One-USD-Every-15-years-500");
            return prev;
        }, { replace: true });
        // Scroll to top to show the new plan
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Store planId in localStorage when component mounts
    useEffect(() => {
        if (planId) {
            localStorage.setItem('planId', planId);
        }
    }, [planId]);

    useEffect(() => {
        const fetchPlanDetails = async () => {
            if (!initialPlanId) return;

            const cleanInitialPlanId = initialPlanId.replace(/-\d+$/, '');
            setIsLoadingPlan(true);
            try {
                // Fetch both monthly and yearly plan details at once using clean plan IDs without numbers
                const basePlanId = cleanInitialPlanId.replace(/(Monthly|Yearly)/g, "");
                const monthlyPlanId = `${basePlanId}Monthly`;
                const yearlyPlanId = `${basePlanId}Yearly`;

                // Fetch both plans in parallel
                const [monthlyResponse, yearlyResponse] = await Promise.all([
                    chargebeeService.getPlanById(monthlyPlanId),
                    chargebeeService.getPlanById(yearlyPlanId)
                ]);

                // Store both plan details
                setPlanDetails(isYearly ? yearlyResponse.data : monthlyResponse.data);
                setMonthlyPlanDetails(isYearly ? monthlyResponse.data : yearlyResponse.data);

            } catch (error) {
                console.error('Failed to fetch plan details:', error);
                // Fallback: try to fetch just the current plan
                try {
                    const response = await chargebeeService.getPlanById(cleanInitialPlanId);
                    setPlanDetails(response.data);
                } catch (fallbackError) {
                    console.error('Failed to fetch fallback plan details:', fallbackError);
                }
            } finally {
                setIsLoadingPlan(false);
            }
        };

        fetchPlanDetails();
    }, [initialPlanId]); // Only depend on initialPlanId, not planId

    useEffect(() => {
        // Extract plan details from planId and console log them
        if (planId) {
            // Check if this is one of the three specific sale plans
            if (PLAN_CONFIGS[planId]) {
                const config = PLAN_CONFIGS[planId];
                setCurrentPlanConfig(config);
                
                // Set plan features based on configuration
                const features = {
                    planType: config.planId.includes('All-In-One') ? PLAN_NAMES.ALL_IN_ONE : PLAN_NAMES.AUTOMATED_GOLD,
                    currency: 'USD',
                    duration: 'Yearly',
                    attendees: parseInt(planId.match(/-(\d+)$/)?.[1] || '0'),
                    price: config.price,
                    storage: config.features.find(f => f.includes('GB')) || '2 GB',
                    webinars: 'Unlimited'
                };
                
                setPlanFeatures(features);
                setPlanPrice(config.price);
                setPlanType(config.planId.includes('All-In-One') ? PLAN_NAMES.ALL_IN_ONE : PLAN_NAMES.AUTOMATED_GOLD);
                setLeads(parseInt(planId.match(/-(\d+)$/)?.[1] || '0'));
                setPlanWebinars('Unlimited');
                setPlanStorage(config.features.find(f => f.includes('GB')) || '2 GB');
                
                return; // Exit early since we've set everything from config
            }
            
            // Parse the planId for other plans
            const parts = planId.split('-');
            let extractedPlanType: string;
            let currency: string;
            let duration: string;
            let extractedAttendees: number;
            let liveAttendees: number = 0;
            let automatedAttendees: number = 0;

            if (parts[0] === 'All') {
                extractedPlanType = PLAN_NAMES.ALL_IN_ONE; // "All-In-One"
                currency = parts[3]; // USD
                duration = parts[4]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[5]); // e.g., 750

                // Find the matching plan to get the label
                const selectedPlan = LIVE_AUTO_PRICES.find(plan => plan.value === extractedAttendees.toString());
                if (selectedPlan) {
                    // Parse the label to extract live and automated attendees, handling comma-separated numbers
                    const labelMatch = selectedPlan.label.match(/([\d,]+)\s+Live\s+&\s+([\d,]+)\s+Automated/);
                    if (labelMatch) {
                        // Remove commas and convert to numbers
                        liveAttendees = parseInt(labelMatch[1].replace(/,/g, ''));
                        automatedAttendees = parseInt(labelMatch[2].replace(/,/g, ''));
                    }
                }
            } else {
                extractedPlanType = parts[0] + '-' + parts[1]; // Could be LIVE_WEBINARS or AUTOMATED_GOLD
                currency = parts[2]; // USD
                duration = parts[3]; // Yearly/Monthly
                extractedAttendees = parseInt(parts[4]); // e.g., 250
            }

            // Validate that the extracted plan type is one of the valid plan names
            const validPlanTypes = [
                PLAN_NAMES.LIVE_WEBINARS,
                PLAN_NAMES.AUTOMATED_GOLD,
                PLAN_NAMES.ALL_IN_ONE
            ];

            if (!validPlanTypes.includes(extractedPlanType)) {
                console.log('Invalid plan type:', extractedPlanType, 'redirecting to pricing page');
                window.location.href = 'https://easywebinar.com/pricing/';
                return;
            }

            // Get pricing data based on plan type
            let pricingData: PricingTier[];
            let selectedPlan: PricingTier | undefined;

            switch (extractedPlanType) {
                case PLAN_NAMES.LIVE_WEBINARS:
                    pricingData = LIVE_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                case PLAN_NAMES.AUTOMATED_GOLD:
                    pricingData = AUTOMATED_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                case PLAN_NAMES.ALL_IN_ONE:
                    pricingData = LIVE_AUTO_PRICES;
                    selectedPlan = pricingData.find((plan: PricingTier) => plan.value === extractedAttendees.toString());
                    break;
                default:
                    console.log('Unknown plan type:', extractedPlanType);
                    return;
            }

            if (!selectedPlan) {
                console.log('No matching plan found for attendees:', extractedAttendees);
                return;
            }

            // Update the features object
            const features = {
                planType: extractedPlanType,
                currency,
                duration,
                attendees: extractedAttendees ?? 0,
                liveAttendees: liveAttendees,
                automatedAttendees: automatedAttendees,
                price: duration === 'Yearly' ? (selectedPlan.annual ?? 0) : (selectedPlan.monthly ?? 0),
                storage: selectedPlan.storage,
                webinars: 'Unlimited'
            };

            // Get plan-specific features based on plan type
            let planFeatures = [];
            switch (extractedPlanType) {
                case PLAN_NAMES.LIVE_WEBINARS:
                    planFeatures = [
                        `Up to ${extractedAttendees} attendees`,
                        'Unlimited live webinars',
                        'Custom landing pages + smart scheduling',
                        `Up to ${selectedPlan.storage} storage space`,
                        'Share offers, files & links',
                        'Polls, Q&A, and emoji reactions'
                    ];
                    break;
                case PLAN_NAMES.AUTOMATED_GOLD:
                    planFeatures = [
                        `Up to ${extractedAttendees} attendees`,
                        'Unlimited automated events',
                        'Just-in-time scheduling',
                        'Preloaded + live chats & real-time replays',
                        'Automated, segmented email campaigns',
                        'Data export & analytics'
                    ];
                    break;
                case PLAN_NAMES.ALL_IN_ONE:
                    planFeatures = [
                        `Up to ${extractedAttendees} total attendees`,
                        'Unlimited live & automated webinars',
                        'Turn replays into automated webinars',
                        'Auto-played polls, CTAs, and chat prompts',
                        'Priority support & success onboarding',
                        'CRM Tool Integrations'
                    ];
                    break;
            }

            // Update all state variables at once to prevent multiple re-renders
            setPlanFeatures(features);
            setPlanType(extractedPlanType);
            setLeads(extractedAttendees);
            setLiveAttendees(liveAttendees);
            setAutomatedAttendees(automatedAttendees);
            setPlanPrice(duration === 'Yearly' ? (selectedPlan.annual ?? 0) : (selectedPlan.monthly ?? 0));
            setPlanWebinars('Unlimited');
            setPlanStorage(selectedPlan.storage);
        }
    }, [planId]);

    const calculateDynamicPricing = () => {
        if (isLoadingPlan || !planDetails) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        const quantity = planId ? parseInt(planId.match(/-(\d+)$/)?.[1] || '0') : 0;

        if (planId === PLAN_NAMES.FREE_TRIAL) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        // Find the current plan tier
        const currentTier = planDetails?.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return quantity >= tier.starting_unit;
            }
            return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
        });

        if (!currentTier) {
            return {
                currentPrice: '$00.00',
                alternativePrice: '$00.00',
                savings: '$00.00',
                savingsPercentage: 0,
                isYearlySelected: isYearly,
                currentPeriod: isYearly ? 'year' : 'month',
                alternativePeriod: isYearly ? 'month' : 'year'
            };
        }

        // Get current plan price
        const currentPrice = currentTier.price / 100; // Convert cents to dollars
        let discountedCurrentPrice = currentPrice;

        // Apply discount if promo code is applied
        if (appliedPromo) {
            if (appliedPromo.type === 'percentage') {
                discountedCurrentPrice = currentPrice * (1 - appliedPromo.discount / 100);
            } else if (appliedPromo.type === 'fixed_amount') {
                discountedCurrentPrice = Math.max(0, currentPrice - (appliedPromo.discount / 100));
            }
        }

        // Calculate alternative pricing
        let alternativePrice = 0;
        let alternativeTier = null;

        if (isYearly) {
            // If yearly is selected, calculate monthly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate monthly price as 1/12 of yearly price
                    alternativePrice = currentPrice;
                }
            } else {
                // Fallback: estimate monthly price as 1/12 of yearly price
                alternativePrice = currentPrice;
            }
        } else {
            // If monthly is selected, calculate yearly equivalent
            if (monthlyPlanDetails) {
                // Use the fetched monthly plan details
                alternativeTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (alternativeTier) {
                    alternativePrice = alternativeTier.price / 100; // Convert cents to dollars

                    // Apply same discount to alternative price
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            alternativePrice = alternativePrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            alternativePrice = Math.max(0, alternativePrice - (appliedPromo.discount / 100));
                        }
                    }

                    // Calculate yearly equivalent of monthly price
                    alternativePrice = alternativePrice * 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    alternativePrice = currentPrice * 12;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                alternativePrice = currentPrice * 12;
            }
        }

        // Calculate static monthly and yearly prices
        let monthlyPrice = 0;
        let yearlyPrice = 0;

        // Calculate monthly price
        if (isYearly) {
            // If yearly is selected, use the monthly plan details
            if (monthlyPlanDetails) {
                const monthlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        } else {
            // If monthly is selected, use the current plan details
            if (planDetails && planDetails.periodUnit === 'month') {
                const monthlyTier = planDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (monthlyTier) {
                    monthlyPrice = monthlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            monthlyPrice = monthlyPrice * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            monthlyPrice = Math.max(0, monthlyPrice - (appliedPromo.discount / 100));
                        }
                    }
                }
            }
        }

        // Calculate yearly price (monthly equivalent)
        if (isYearly) {
            // If yearly is selected, use the current yearly price
            yearlyPrice = discountedCurrentPrice / 12;
        } else {
            // If monthly is selected, use the actual yearly price from alternative plan details
            if (monthlyPlanDetails && monthlyPlanDetails.periodUnit === 'year') {
                // Use the fetched yearly plan details
                const yearlyTier = monthlyPlanDetails?.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                });

                if (yearlyTier) {
                    let yearlyPriceValue = yearlyTier.price / 100; // Convert cents to dollars
                    // Apply discount if promo code is applied
                    if (appliedPromo) {
                        if (appliedPromo.type === 'percentage') {
                            yearlyPriceValue = yearlyPriceValue * (1 - appliedPromo.discount / 100);
                        } else if (appliedPromo.type === 'fixed_amount') {
                            yearlyPriceValue = Math.max(0, yearlyPriceValue - (appliedPromo.discount / 100));
                        }
                    }
                    yearlyPrice = yearlyPriceValue / 12;
                } else {
                    // Fallback: estimate yearly price as 12x monthly price
                    yearlyPrice = discountedCurrentPrice;
                }
            } else {
                // Fallback: estimate yearly price as 12x monthly price
                yearlyPrice = discountedCurrentPrice;
            }
        }

        // Calculate savings
        let savings = 0;
        let savingsPercentage = 0;

        if (isYearly) {
            // If yearly is selected, savings = monthly equivalent - yearly price
            // Use original prices for savings calculation
            const originalAlternativePrice = alternativePrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const originalCurrentPrice = currentPrice;
            savings = Math.abs(originalAlternativePrice - originalCurrentPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === 'percentage') {
                    savings += (originalCurrentPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === 'fixed_amount') {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage = originalAlternativePrice > 0 ? Math.round((savings / originalAlternativePrice) * 100) : 0;
        } else {
            // If monthly is selected, savings = (monthly price × 12) - actual yearly price
            // Use original prices for savings calculation
            const originalMonthlyPrice = monthlyPrice / (appliedPromo ? (1 - appliedPromo.discount / 100) : 1);
            const yearlyEquivalent = originalMonthlyPrice * 12;
            const actualYearlyPrice = monthlyPlanDetails ?
                (monthlyPlanDetails.tiers.find((tier: any) => {
                    if (!tier.ending_unit) {
                        return quantity >= tier.starting_unit;
                    }
                    return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
                })?.price || 0) / 100 : 0;

            savings = Math.abs(yearlyEquivalent - actualYearlyPrice);

            // Add promo code discount to savings if applied
            if (appliedPromo) {
                if (appliedPromo.type === 'percentage') {
                    savings += (actualYearlyPrice * appliedPromo.discount / 100);
                } else if (appliedPromo.type === 'fixed_amount') {
                    savings += (appliedPromo.discount / 100);
                }
            }

            savingsPercentage = actualYearlyPrice > 0 ? Math.round((savings / actualYearlyPrice) * 100) : 0;
        }

        return {
            currentPrice: `$${Math.round(discountedCurrentPrice)}`,
            originalPrice: `$${Math.round(currentPrice)}`,
            alternativePrice: `$${Math.round(alternativePrice)}`,
            savings: `$${Math.round(savings)}`,
            savingsPercentage,
            isYearlySelected: isYearly,
            currentPeriod: isYearly ? 'year' : 'month',
            alternativePeriod: isYearly ? 'month' : 'year',
            currentPriceValue: discountedCurrentPrice || 0,
            originalPriceValue: currentPrice || 0,
            alternativePriceValue: alternativePrice || 0,
            monthlyPrice: `$${Math.round(monthlyPrice)}`,
            yearlyPrice: `$${Math.round(yearlyPrice)}`
        };
    };

    const validatePassword = (password: string) => {
        const minLength = 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);

        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasNumber) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        if (!hasUppercase) {
            return 'Password must contain at least one uppercase letter';
        }
        if (!hasLowercase) {
            return 'Password must contain at least one lowercase letter';
        }
        return '';
    };



    const validateForm = () => {
        const errors = {
            email: '',
            password: '',
            subdomain: ''
        };
        let isValid = true;

        // Check required fields
        const emailValidation = validateEmail(formData.email);
        if (!emailValidation.isValid) {
            errors.email = emailValidation.error || "Please enter a valid email";
            isValid = false;
        }

        // Password validation
        if (!formData.password.trim()) {
            errors.password = 'Password is required';
            setPasswordError('Password is required');
            isValid = false;
        } else {
            const passwordValidationError = validatePassword(formData.password);
            if (passwordValidationError) {
                errors.password = passwordValidationError;
                setPasswordError(passwordValidationError);
                isValid = false;
            } else {
                setPasswordError('');
            }
        }

        setFormErrors(errors);
        return isValid;
    };


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For subdomain field, convert to lowercase
        const processedValue = name === 'subdomain' ? value.toLowerCase() : value;

        // Update the form data with the raw input value
        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));

        // Clear error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));

        if (name === 'password') {
            if (!value.trim()) {
                setPasswordError('Password is required');
            } else {
                setPasswordError(validatePassword(value));
            }
        }
    };



    const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAcceptedTerms(event.target.checked);
        if (event.target.checked) {
            setTermsError('');
        }
    };

    const [verificationDialogOpen, setVerificationDialogOpen] = React.useState(false);

    const handleVerificationDialogOpen = () => {
        setVerificationDialogOpen(true);
    };

    const handleVerificationDialogClose = async () => {
        setVerificationDialogOpen(false);
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name", "Value": currentPlanConfig?.planName || '' },
                { "Attribute": "mx_Status", "Value": "Pending Verification" }
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        navigate('/login');
    };

    // Helper function to clear UTM params from localStorage
    const clearUtmParamsFromStorage = () => {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_medium');
        localStorage.removeItem('utm_campaign');
        localStorage.removeItem('utm_content');
        localStorage.removeItem('utm_term');
        localStorage.removeItem('ad_id');
        localStorage.removeItem('fbc_id');
        localStorage.removeItem('h_ad_id');
        localStorage.removeItem('utm_id');
        localStorage.removeItem('gc_id');
        localStorage.removeItem('h_ga_id');
        localStorage.removeItem('h_keyword_id');
        localStorage.removeItem('h_keyword');
        localStorage.removeItem('h_placement');
        localStorage.removeItem('g_special_campaign');
    };

    const handleVerificationDialogProceed = async () => {
        // handleVerificationDialogClose();
        setVerificationDialogOpen(false);
        try {
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Email Verified" });
            const leadData = {
                "leadId": leadSquaredId,
                "fields": [
                    { "Attribute": "mx_Plan_Name", "Value": currentPlanConfig?.planName || '' },
                    { "Attribute": "mx_Status", "Value": "Active" }
                ]
            }
            await LeadsquaredService.updateLsField(leadData);
        } catch (error) {
            console.error('Error updating lead data:', error);
        }

        // Clear UTM parameters from localStorage after successful signup
        clearUtmParamsFromStorage();
  
        // Pass plan data through URL parameters
        const planData = {
            price: currentPlanConfig ? currentPlanConfig.price : 3995,
            currency: 'USD',
            coupon: appliedPromo?.code || 'WORKSHOP50',
            plan_name: currentPlanConfig ? currentPlanConfig.planName : 'Lifetime Pro Plan',
            customer_type: "with_cc"
        };

        // Encode plan data as URL parameters
        const planDataParams = new URLSearchParams({
            ...planData,
            price: planData.price.toString()
        }).toString();

        window.location.href = `/loading-dashboard?ew_email=${formData.email}&planId=${planId}&${planDataParams}`;
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 24,
        height: 24,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#178EFC',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }


    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSocialSignIn = (provider: SocialProvider) => {
        try {
            const authUrl = config.sso_auth_url;
            const planIdParam = searchParams.get('planId');

            const utmParams = {
                utm_source: localStorage.getItem('utm_source'),
                utm_medium: localStorage.getItem('utm_medium'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_content: localStorage.getItem('utm_content'),
                utm_term: localStorage.getItem('utm_term'),
                ad_id: localStorage.getItem('ad_id'),
                fbc_id: localStorage.getItem('fbc_id'),
                h_ad_id: localStorage.getItem('h_ad_id'),
                utm_id: localStorage.getItem('utm_id'),
                gc_id: localStorage.getItem('gc_id'),
                h_ga_id: localStorage.getItem('h_ga_id'),
                h_keyword_id: localStorage.getItem('h_keyword_id'),
                h_keyword: localStorage.getItem('h_keyword'),
                h_placement: localStorage.getItem('h_placement'),
                g_special_campaign: localStorage.getItem('g_special_campaign'),
            }

            // Filter out null/undefined/empty values from UTM params
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined && value.trim() !== '')
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value?.trim() }), {});

            // Create state parameter with additional metadata
            const stateData = {
                isRegistration: true,
                timestamp: Date.now(),
                flow: 'first-flow',
                ...(planIdParam && { planId: planIdParam }), // Only include planId if it exists
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams }) // Only include UTM params if they exist
            };

            const baseParams = {
                client_id: config.sso_client_id,
                response_type: 'code',
                scope: 'email openid profile phone',
                redirect_uri: `${window.location.origin}/auth/sso/callback`,
                state: JSON.stringify(stateData),
                prompt: 'select_account'
            };

            const params = new URLSearchParams({
                ...baseParams,
                identity_provider: provider,
            });

            window.location.href = `${authUrl}?${params.toString()}`;
        } catch (error) {
            console.error('Google Sign In Error:', error);
            toast.error('Failed to initialize Google Sign In');
        }
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');


    const handleGetStarted = async () => {
        try {
            let cardTokenResult = null;
            setIsLoading(true);

            // Email validation
            const emailValidation = validateEmail(formData.email);
            if (!emailValidation.isValid) {
                setFormErrors(prev => ({
                    ...prev,
                    email: emailValidation.error || "Please enter a valid email"
                }));
                setIsLoading(false);
                return;
            }

            // Check if email exists
            const emailCheckResponse = await AuthService.checkEmailExists(formData.email);
            if (emailCheckResponse.data?.exists) {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }

                try {
                    await chargebeeService.changePlanByEmail({
                        email: formData.email,
                        planId: 'All-In-One-USD-Every-15-years',
                        planUnits: 500,
                        cardToken: cardTokenResult
                    });

                    logEvent(formData.email, EVENT_TYPES.BUNDLE_PURCHASE, {
                        bundleType: 'workshopBundleLifetime',
                        email: formData.email,
                        planId: 'All-In-One-USD-Every-15-years',
                        planUnits: 500,
                        amount: 3995,
                        flow: 'upgrade',
                        step: 'success'
                    });

                    toast.success('Plan changed successfully');
                    navigate('/login');
                } catch (error: any) {
                    console.error('Error changing plan:', error);
                    toast.error('Failed to change plan. Please try again.');
                }
                setIsLoading(false);
                return;
            }

            // Auto-generate firstName and lastName from email
            const firstName = generateFirstName(formData.email);
            const lastName = "";

            // Generate subdomain from first name
            const baseSubdomain = firstName.toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // Log signup event
            try {
                const eventData = {
                    step: SIGNUP_STEPS.FORM,
                    password: formData.password,
                    planId: 'All-In-One-USD-Every-15-years',
                    planUnits: 500,
                    signupFlow: SIGNUP_FLOWS.PRICING_PAGE,
                    planName: 'All-In-One-USD-Every-15-years',
                    planPrice: 3995,
                    saleType: 'WorkshopBundleLifetime'
                }
                
                await logEvent(formData.email, EVENT_TYPES.SIGNUP, eventData);
            } catch (error: any) {
                console.error('Error logging signup event:', error);
                // Don't block the flow if event logging fails
            }

            // Create lead in Leadsquared
            try {
                let utm_Data = {
                    utm_source: localStorage.getItem('utm_source'),
                    utm_medium: localStorage.getItem('utm_medium'),
                    utm_campaign: localStorage.getItem('utm_campaign'),
                    utm_content: localStorage.getItem('utm_content'),
                    utm_term: localStorage.getItem('utm_term'),
                    ad_id: localStorage.getItem('ad_id'),
                    fbc_id: localStorage.getItem('fbc_id'),
                    h_ad_id: localStorage.getItem('h_ad_id'),
                    utm_id: localStorage.getItem('utm_id'),
                    gc_id: localStorage.getItem('gc_id'),
                    h_ga_id: localStorage.getItem('h_ga_id'),
                    h_keyword_id: localStorage.getItem('h_keyword_id'),
                    h_keyword: localStorage.getItem('h_keyword'),
                    h_placement: localStorage.getItem('h_placement'),
                    g_special_campaign: localStorage.getItem('g_special_campaign'),
                }

                // Create form data with generated firstName and lastName
                const formDataWithDetails = {
                    firstName,
                    lastName,
                    email: formData.email,
                    password: formData.password,
                    timezone: getTimezoneString(),
                    subdomain: subdomainResponse.subdomain,
                };

                const LsId = await LeadsquaredService.createtLead(formDataWithDetails, "", utm_Data);
                await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Signup Attempt - pricing" });
                const leadData = {
                    "leadId": LsId,
                    "fields": [
                        { "Attribute": "mx_Source_lp", "Value": searchParams.get('Source_IP'), },
                    ]
                }
                await LeadsquaredService.updateLsField(leadData);
                setLeadSquaredId(LsId);
            } catch (error: any) {
                console.error('Error creating lead:', error);
            }

            // Add domain validation here
            if (!formData.subdomain.trim()) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'Domain is required'
                }));
                setDomainSuggestions([]);
                setIsLoading(false);
                return;
            } else if (!/^[a-zA-Z0-9-]+$/.test(formData.subdomain)) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'Domain can only contain letters, numbers, and hyphens'
                }));
                setDomainSuggestions([]);
                setIsLoading(false);
                return;
            }

            // Check domain availability first
            const domainResponse = await AuthService.checkSubDomainAvailability(
                formData.subdomain,
                Applications.EASYWEBINAR
            );

            if (!domainResponse.available) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'This domain is already taken. Please try another one.'
                }));
                // Set domain suggestions if they exist
                if (domainResponse.suggestions && domainResponse.suggestions.length > 0) {
                    setDomainSuggestions(domainResponse.suggestions);
                } else {
                    setDomainSuggestions([]);
                }
                setIsLoading(false);
                return;
            }

            // Clear suggestions if domain is available
            setDomainSuggestions([]);

            // Get planId based on payment option
            const selectedPlanId = paymentOption === 'pay-in-full' 
                ? getBasePlanId() 
                : getInstallmentPlanId();

            const planUnits = getPlanUnits();

            let billingCycles;
            let itemTiers;

            if(paymentOption === 'installments'){
                billingCycles = 3;
                itemTiers = [
                    {
                        item_price_id: selectedPlanId,
                        starting_unit: 1,
                        ending_unit: planUnits,
                        price: (currentPlanConfig?.InstallmentPrice || 0)/3 * 100 // Convert to cents
                    },
                    {
                        item_price_id: selectedPlanId,
                        starting_unit: planUnits + 1,
                        price: ((currentPlanConfig?.InstallmentPrice || 0)/3 || 0)* 100 // Convert to cents
                    }
                ];
            }

            // Only process card if there's a plan and it's not a free trial
            if (selectedPlanId && !isTrial) {
                // Check if card has any validation errors
                if (cardError) {
                    toast.error('Please fix card validation errors before proceeding');
                    setIsLoading(false);
                    return;
                }

                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    setIsLoading(false);
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    setIsLoading(false);
                    return;
                }
            }

            // Get UTM parameters directly from URL
            const urlParams = new URLSearchParams(window.location.search);

            const utmParams = {
                utm_source: urlParams.get('utm_source'),
                utm_medium: urlParams.get('utm_medium'),
                utm_campaign: urlParams.get('utm_campaign'),
                utm_content: urlParams.get('utm_content'),
                utm_term: urlParams.get('utm_term'),
                ad_id: urlParams.get('ad_id'),
                fbc_id: urlParams.get('fbc_id'),
                h_ad_id: urlParams.get('h_ad_id'),
                utm_id: urlParams.get('utm_id'),
                gc_id: urlParams.get('gc_id'),
                h_ga_id: urlParams.get('h_ga_id'),
                h_keyword_id: urlParams.get('h_keyword_id'),
                h_keyword: urlParams.get('h_keyword'),
                h_placement: urlParams.get('h_placement'),
                g_special_campaign: urlParams.get('g_special_campaign'),
            };

            // Remove null/undefined values from the UTM params object
            const cleanUtmParams = Object.entries(utmParams)
                .filter(([_, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

            // firstName and lastName were already generated from email earlier in this function
            const signupData = {
                ...formData,
                firstName,
                lastName,
                phoneNumber: "",
                timezone: getTimezoneString(),
                planId: selectedPlanId,
                planUnits: planUnits,
                cardToken: cardTokenResult,
                trialEnd: noTrial ? 0 : undefined,
                ...(billingCycles && { billingCycles }),
                ...(itemTiers && { itemTiers }),
                // Include UTM parameters if they exist
                ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams })
            };

            const response = await AuthService.signup(signupData);

            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();

            // Clear UTM params on successful signup
            clearUtmParamsFromStorage();
            toast.success('Signup successful! Please verify your account.');
            try {
                await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
                
                if(planDetails?.id === "free-trial-plan"){
                    await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Free Plan" });
                }else{
                    if(paymentOption === 'installments'){
                        const activityNote = `${currentPlanConfig?.planName || ''} - ${planUnits} - Installments - Holiday Sale`;
                        await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: getBasePlanId() || '', activityNote: activityNote });
                    }else{
                        const activityNote = `${currentPlanConfig?.planName || ''} - ${planUnits} - Pay in Full - Holiday Sale`;
                        await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: getBasePlanId() || '', activityNote: activityNote });
                    }
                }
            } catch (error: any) {
                console.error('Error joining activities:', error);
            }
        } catch (error: any) {
            console.error('Signup failed:', error);
            setDomainSuggestions([]);
            // Clear UTM params on signup failure too
            clearUtmParamsFromStorage();
            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
                toast.error('Invalid card details. Please try again.');
            } else {
                toast.error(error.message || 'An error occurred during signup. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateCoupon = async (codeToValidate?: string) => {
        const code = codeToValidate || promoCode.trim();
        if (!code) {
            setPromoError('Please enter a promo code');
            toast.error('Please enter a promo code');
            return;
        }

        try {
            const response = await chargebeeService.validateCoupon(
                code,
                getBasePlanId()
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount,
                    type: coupon.discountType
                });
                setPromoError('');
                setShowPromoField(false);
                if (!codeToValidate) {
                    toast.success('Promo code applied successfully!');
                }
            } else {
                setPromoError(response.data.error || 'Invalid promo code');
                setAppliedPromo(null);
                if (!codeToValidate) {
                    toast.error(response.data.error || 'Invalid promo code');
                }
            }
        } catch (error: any) {
            console.error('Error validating coupon:', error);
            setPromoError('Failed to validate promo code');
            setAppliedPromo(null);
            if (!codeToValidate) {
                toast.error('Failed to validate promo code. Please try again.');
            }
        }
    };


    // Inside the Signup component, add a state variable for planFeatures
    const [planFeatures, setPlanFeatures] = useState<{
        planType: string;
        currency: string;
        duration: string;
        attendees: number;
        liveAttendees?: number;
        automatedAttendees?: number;
        price: number | string;
        webinars: number | string;
        storage: string;
    } | null>(null);

    // Add new state variables to store the extracted values
    const [planType, setPlanType] = useState<string>('');
    const [leads, setLeads] = useState<number>(0);
    const [liveAttendees, setLiveAttendees] = useState<number | undefined>(undefined);
    const [automatedAttendees, setAutomatedAttendees] = useState<number | undefined>(undefined);
    const [planPrice, setPlanPrice] = useState<number | string>('');
    const [planWebinars, setPlanWebinars] = useState<number | string>('');
    const [planStorage, setPlanStorage] = useState<string>('');

    function captureUTMParams() {
        const urlParams = new URLSearchParams(window.location.search);

        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');
        const utmContent = urlParams.get('utm_content');
        const utmTerm = urlParams.get('utm_term');
        const ad_id = urlParams.get('ad_id');
        const fbc_id = urlParams.get('fbc_id');
        const h_ad_id = urlParams.get('h_ad_id');
        const utm_id = urlParams.get('utm_id');
        const email = urlParams.get('email');
        const gc_id = urlParams.get('gc_id');
        const h_ga_id = urlParams.get('h_ga_id');
        const h_keyword_id = urlParams.get('h_keyword_id');
        const h_keyword = urlParams.get('h_keyword');
        const h_placement = urlParams.get('h_placement');
        const g_special_campaign = urlParams.get('g_special_campaign');

        if (utmSource) localStorage.setItem('utm_source', utmSource);
        if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
        if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);
        if (utmContent) localStorage.setItem('utm_content', utmContent);
        if (utmTerm) localStorage.setItem('utm_term', utmTerm);
        if (ad_id) localStorage.setItem('ad_id', ad_id);
        if (fbc_id) localStorage.setItem('fbc_id', fbc_id);
        if (h_ad_id) localStorage.setItem('h_ad_id', h_ad_id);
        if (utm_id) localStorage.setItem('utm_id', utm_id);
        if (gc_id) localStorage.setItem('gc_id', gc_id);
        if (h_ga_id) localStorage.setItem('h_ga_id', h_ga_id);
        if (h_keyword_id) localStorage.setItem('h_keyword_id', h_keyword_id);
        if (h_keyword) localStorage.setItem('h_keyword', h_keyword);
        if (h_placement) localStorage.setItem('h_placement', h_placement);
        if (g_special_campaign) localStorage.setItem('g_special_campaign', g_special_campaign);
        // Set email from URL parameter if present
        if (email) {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }

    // Add useEffect for capturing UTM parameters
    useEffect(() => {
        captureUTMParams();
    }, []);

    // Check for BuyNow parameter on page load
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const buyNow = urlParams.get('BuyNow') === 'true';
        setNoTrial(true);
    }, []);

    return (
        <>            
            <Box
                sx={{
                    minHeight: "100vh",
                    width: "100vw",
                    background: `
                linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
                linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
            `,
                    color: "#1f2937",
                    fontFamily: "Inter",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: { xs: "16px 24px", sm: "24px 32px" },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={LogoDarkMode}
                            alt="logo"
                            style={{ height: 24, cursor: "pointer", maxWidth: "100%" }}
                            onClick={() => window.open("https://easywebinar.com/", "_blank")}
                        />
                    </Box>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward />}
                        size="small"
                        onClick={() => navigate("/login")}
                        sx={{
                            bgcolor: "#6066E9",
                            color: "#fff",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { bgcolor: "#4B4EB5" },
                        }}
                    >
                        Login
                    </Button>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: {
                            xs: "calc(100vh - 120px)",
                            sm: "calc(100vh - 100px)",
                            md: "calc(100vh - 80px)",
                        },
                        p: { xs: 1, sm: 2 },
                        pt: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    {/* Main container with border - responsive sizing */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: "90%", md: "1200px", lg: "1400px" },
                            maxWidth: { xs: "600px", md: "none" },
                            height: { xs: "auto" },
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            bgcolor: "#ffffff",
                            boxShadow: "0 4px 32px 0 rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        {/* Left side - Promotional Section */}
                        <Box
                            sx={{
                                width: "50%",
                                bgcolor: "#f8fafc",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: { xs: "none", md: "flex" },
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                borderRadius: { xs: "18px", md: "18px 0 0 18px" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            <Box sx={{ textAlign: 'left', width: '100%' }}>

                                    {/* Light Blue-Gray Panel */}
                                    <Box
                                        sx={{
                                            backgroundColor: '#F0F4F8',
                                            borderRadius: '12px',
                                            padding: '24px',
                                            mb: '24px',
                                        }}
                                    >
                                        {/* Plan Name Header - Centered */}
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '18px', sm: '20px', md: '22px' },
                                                fontWeight: 700,
                                                mb: '24px',
                                                textAlign: 'center',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            Professional Plus Bundle (Lifetime Access)
                                        </Typography>

                                        {/* What's Included Section */}
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: { xs: '18px', md: '20px' },
                                                fontWeight: 700,
                                                mb: '16px',
                                            }}
                                        >
                                            What's Included :
                                        </Typography>

                                        <Box sx={{ mb: '24px' }}>
                                            {/* Item 1: EasyWebinar Professional */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    EasyWebinar Professional (Lifetime Access) – FREE ($3,995 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 2: EasyCRM Sales Engine */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    EasyCRM Sales Engine – FREE ($1,200+ value)
                                                </Typography>
                                            </Box>

                                            {/* Item 3: Elite Webinar Mastery Course */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Elite Webinar Mastery Course ($1,300 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 4: Monthly Webinar Pass */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Monthly Webinar Pass (12 Months) ($600 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 5: Sales Experience Community */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Sales Experience Community (12 Months) ($1,188 value)
                                                </Typography>
                                            </Box>

                                            {/* Item 6: Sales Experience Digital Book */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    Sales Experience Digital Book
                                                </Typography>
                                            </Box>

                                            {/* Item 7: AI Webinar Builder */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        flex: 1,
                                                    }}
                                                >
                                                    AI Webinar Builder
                                                </Typography>
                                            </Box>

                                            {/* Item 8: Expert Platform Migration */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: '#1f2937',
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        Expert Platform Migration ($1,000 value)
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#6B7280',
                                                            fontSize: '13px',
                                                            fontWeight: 400,
                                                            ml: 0,
                                                        }}
                                                    >
                                                        Complete migration of webinars, contacts & automations with setup, testing & QA
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Item 9: Go-To-Market Strategy Audit */}
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'flex-start', 
                                                mb: '8px',
                                            }}>
                                                <Box sx={{ 
                                                    color: '#1f2937', 
                                                    fontSize: '16px', 
                                                    fontWeight: 700,
                                                    mr: '12px', 
                                                    mt: '2px', 
                                                    flexShrink: 0,
                                                    lineHeight: 1,
                                                }}>
                                                    ✓
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '100%', flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: '#1f2937',
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        Go-To-Market Strategy Audit ($2,000 value)
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#6B7280',
                                                            fontSize: '13px',
                                                            fontWeight: 400,
                                                            ml: 0,
                                                        }}
                                                    >
                                                        Personalized funnel audit with a clear action plan to boost conversions
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                {/* Savings Breakdown Section - Three Horizontal Boxes */}
                                <Box sx={{ mt: '24px' }}>
                                    <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#1f2937',
                                                fontSize: '18px',
                                                fontWeight: 700,
                                                mb: '16px',
                                            }}
                                        >
                                            Savings Breakdown
                                        </Typography>
                                        <Box sx={{ display: 'flex', gap: '12px', flexDirection: { xs: 'column', sm: 'row' } }}>
                                            {/* Total Value Box */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#F5F5F5',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    Total Value:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    $11,283+
                                                </Typography>
                                            </Box>

                                            {/* You Save Box - Dark Green */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#22B060',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#ffffff',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    You Save:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#ffffff',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    $7,288+
                                                </Typography>
                                            </Box>

                                            {/* You Pay Today Box */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    backgroundColor: '#F5F5F5',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        mb: '8px',
                                                    }}
                                                >
                                                    You Pay Today:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: '#1f2937',
                                                        fontSize: '24px',
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    ${currentPlanConfig?.price || 3995}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                        </Box>

                        {/* Right side - Form Section */}
                        <Box
                            sx={{
                                width: { xs: "100%", md: "50%" },
                                bgcolor: "#ffffff",
                                p: { xs: 3, sm: 4, md: 6 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: { xs: "18px", md: "0 18px 18px 0" },
                                minHeight: { xs: "500px", md: "auto" },
                            }}
                        >
                            {noTrial ? (
                                <>
                                    <Box>
                                            {/* Title - Centered */}
                                            <Typography
                                                color="#333333"
                                                fontWeight="700"
                                                fontSize={{ xs: "24px", xl: "30px" }}
                                                lineHeight="normal"
                                                mb="16px"
                                                textAlign="center"
                                            >
                                                Complete your purchase
                                            </Typography>


                                            {/* Bundle Summary - Flex Layout */}
                                            <Box sx={{ 
                                                pb: '20px', 
                                                borderBottom: '1px dashed rgba(163, 163, 163, 0.24)',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                gap: '16px',
                                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                                            }}>
                                                {/* Left Side - Bundle Name and Attendees */}
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ mb: '12px' }}>
                                                        <Typography
                                                            component="span"
                                                            color="#2B2B30"
                                                            fontSize="16px"
                                                            fontWeight={700}
                                                        >
                                                            {currentPlanConfig ? `${currentPlanConfig.planName} Bundle` : 'Professional Plus Bundle'}
                                                        </Typography>
                                                        <Typography
                                                            component="span"
                                                            color="#6B7280"
                                                            fontSize="16px"
                                                            fontWeight={400}
                                                        >
                                                            {' '}(Lifetime Access)
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        gap: '8px',
                                                        backgroundColor: '#F5F5F5',
                                                        borderRadius: '8px',
                                                        padding: '8px 12px',
                                                        width: 'fit-content',
                                                    }}>
                                                        <People sx={{ color: '#6B7280', fontSize: '18px' }} />
                                                        <Typography
                                                            color="#6B7280"
                                                            fontSize="14px"
                                                            fontWeight={500}
                                                        >
                                                            Attendees{' '}
                                                            {(() => {
                                                                const attendeesText = currentPlanConfig?.attendees || '500 Live + 2,500 Automated/month';
                                                                const parts = attendeesText.includes(' + ') 
                                                                    ? attendeesText.split(' + ') 
                                                                    : [attendeesText];
                                                                
                                                                return parts.map((part, index) => {
                                                                    const trimmedPart = part.trim();
                                                                    const match = trimmedPart.match(/^([\d,]+)\s+(.+)$/);
                                                                    if (match) {
                                                                        const [, number, label] = match;
                                                                        const isLive = label.toLowerCase().includes('live') && !label.toLowerCase().includes('automated');
                                                                        const isAutomated = label.toLowerCase().includes('automated');
                                                                        
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <Typography
                                                                                    component="span"
                                                                                    sx={{
                                                                                        color: isLive ? '#178EFC' : '#7C3AED',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: 600,
                                                                                    }}
                                                                                >
                                                                                    {number}
                                                                                </Typography>
                                                                                <Typography
                                                                                    component="span"
                                                                                    sx={{
                                                                                        color: '#6B7280',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: 500,
                                                                                    }}
                                                                                >
                                                                                    {' '}{label}
                                                                                </Typography>
                                                                                {index < parts.length - 1 && (
                                                                                    <Typography
                                                                                        component="span"
                                                                                        sx={{
                                                                                            color: '#6B7280',
                                                                                            fontSize: '14px',
                                                                                            fontWeight: 500,
                                                                                            mx: '4px',
                                                                                        }}
                                                                                    >
                                                                                        {' '}+{' '}
                                                                                    </Typography>
                                                                                )}
                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                    return null;
                                                                });
                                                            })()}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                {/* Right Side - Pricing */}
                                                <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end', mb: '4px' }}>
                                                        <Typography
                                                            color="#6B7280"
                                                            fontSize="16px"
                                                            fontWeight={700}
                                                            sx={{ textDecoration: 'line-through' }}
                                                        >
                                                            $11,283
                                                        </Typography>
                                                        <Typography
                                                            color="#22B060"
                                                            fontSize="16px"
                                                            fontWeight={700}
                                                        >
                                                            ${currentPlanConfig?.price || 1188}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        <Box sx={{ position: "relative", textAlign: 'center' }}>
                                            <Typography
                                                color="#333333"
                                                fontWeight="700"
                                                fontSize={{ xs: "24px", xl: "30px" }}
                                                lineHeight="normal"
                                                mb="12px"
                                                display="inline-block"
                                                textAlign="center"
                                                sx={{ position: "relative" }}
                                            >
                                                Start your 7-day free trial
                                            </Typography>
                                        </Box>
                                        <Box display="flex" gap="12px" mb="24px" flexWrap="wrap" justifyContent="center" alignItems="center">
                                            <>
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    You’ll only be charged once your trial ends.
                                                </Typography>
                                            </>
                                        </Box>
                                    </>
                                )}

                            <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                    {!isTrial ? (
                                        <>
                                            {/* Payment Options */}
                                            <Box width="100%" mb="24px">
                                                <RadioGroup
                                                    value={paymentOption}
                                                    onChange={(e) => setPaymentOption(e.target.value as 'pay-in-full' | 'installments')}
                                                    sx={{ 
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        gap: '12px',
                                                        '@media (max-width: 600px)': {
                                                            flexDirection: 'column'
                                                        }
                                                    }}
                                                >
                                                    {/* Pay in Full Option */}
                                                    <Box
                                                        onClick={() => setPaymentOption('pay-in-full')}
                                                        sx={{
                                                            flex: 1,
                                                            border: paymentOption === 'pay-in-full' 
                                                                ? '2px solid #7F8FFC' 
                                                                : '1px solid #E5E5E5',
                                                            borderRadius: '8px',
                                                            padding: '10px 12px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            backgroundColor: paymentOption === 'pay-in-full' ? '#F8F9FF' : '#FFFFFF',
                                                            transition: 'all 0.2s ease',
                                                            '&:hover': {
                                                                borderColor: '#7F8FFC',
                                                                backgroundColor: '#F8F9FF'
                                                            }
                                                        }}
                                                    >
                                                        <Radio
                                                            checked={paymentOption === 'pay-in-full'}
                                                            value="pay-in-full"
                                                            sx={{
                                                                color: '#7F8FFC',
                                                                '&.Mui-checked': {
                                                                    color: '#7F8FFC',
                                                                },
                                                                mr: '8px',
                                                                padding: '4px',
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px'
                                                                }
                                                            }}
                                                        />
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 700,
                                                                    color: '#1f2937',
                                                                    mb: '2px',
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                Pay in Full
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                    color: '#7C7D7E',
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                One-time payment • Best value
                                                            </Typography>
                                                        </Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '18px',
                                                                fontWeight: 700,
                                                                color: '#10B981',
                                                                ml: '12px'
                                                            }}
                                                        >
                                                            ${currentPlanConfig ? currentPlanConfig.price : '3,995'}
                                                        </Typography>
                                                    </Box>

                                                    {/* 3 Monthly Installments Option */}
                                                    <Box
                                                        onClick={() => setPaymentOption('installments')}
                                                        sx={{
                                                            flex: 1,
                                                            border: paymentOption === 'installments' 
                                                                ? '2px solid #7F8FFC' 
                                                                : '1px solid #E5E5E5',
                                                            borderRadius: '8px',
                                                            padding: '10px 12px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            backgroundColor: paymentOption === 'installments' ? '#F8F9FF' : '#FFFFFF',
                                                            transition: 'all 0.2s ease',
                                                            '&:hover': {
                                                                borderColor: '#7F8FFC',
                                                                backgroundColor: '#F8F9FF'
                                                            }
                                                        }}
                                                    >
                                                        <Radio
                                                            checked={paymentOption === 'installments'}
                                                            value="installments"
                                                            sx={{
                                                                color: '#7F8FFC',
                                                                '&.Mui-checked': {
                                                                    color: '#7F8FFC',
                                                                },
                                                                mr: '8px',
                                                                padding: '4px',
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: '18px'
                                                                }
                                                            }}
                                                        />
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 700,
                                                                    color: '#1f2937',
                                                                    mb: '2px',
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                3 Monthly Installments
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                    color: '#7C7D7E',
                                                                    mb: '2px',
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                Split your payment into 3 easy installments
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '11px',
                                                                    fontWeight: 400,
                                                                    color: '#7C7D7E',
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                3 x ${currentPlanConfig?.InstallmentPrice ? Math.round(currentPlanConfig.InstallmentPrice / 3) : '0'}/month
                                                            </Typography>
                                                        </Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '18px',
                                                                fontWeight: 700,
                                                                color: '#10B981',
                                                                ml: '12px'
                                                            }}
                                                        >
                                                            ${currentPlanConfig?.InstallmentPrice ? currentPlanConfig.InstallmentPrice : '0'}
                                                        </Typography>
                                                    </Box>
                                                </RadioGroup>
                                            </Box>

                                            {/* Email Field */}
                                            <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb={{ xs: "24px", sm: "24px" }}>
                                                <Grid size={{ xs: 12 }}>
                                                <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                    Work Email
                                                </Typography>
                                                    <TextField
                                                        variant="outlined"
                                                        name="email"
                                                        placeholder="you@company.com"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        error={!!formErrors.email}
                                                        helperText={formErrors.email}
                                                        disabled={isAutoRegistering}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#666666',
                                                            },

                                                            " .MuiInputLabel-root.Mui-focused": {
                                                                color: "inherit",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },

                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Box width="100%" mb="18px">
                                                <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                    Card Details
                                                </Typography>
                                                <Box width="100%" sx={{
                                                    position: "relative",
                                                    "& .CbHosted": {
                                                        borderRadius: '3px',
                                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                                        padding: '14px 16px',
                                                        "&:hover, &--focus": {
                                                            borderColor: '#666666',
                                                        }
                                                    }
                                                }}>
                                                    <CardComponent
                                                        ref={cardRef}
                                                        currency="USD"
                                                        showTestCards={true}
                                                        styles={{
                                                            border: "1px solid #666666",
                                                            base: {
                                                                padding: "14px 16px",
                                                                border: "1px solid #666666",
                                                                fontSize: '16px',
                                                                fontFamily: 'Inter, sans-serif',
                                                                color: '#333333',
                                                                '::placeholder': {
                                                                    color: '#667085',
                                                                },
                                                            },
                                                            invalid: {
                                                                color: '#ff0000',
                                                            },
                                                        }}
                                                        onChange={(status: any) => {
                                                            console.log('Card status:', status);

                                                            if (status.error) {
                                                                setCardError(status.error.message);
                                                                setIsCardValid(false);
                                                            } else if (!status.complete) {
                                                                // Clear error but indicate card is not complete
                                                                setCardError(null);
                                                                setIsCardValid(false);
                                                            } else {
                                                                // Card is complete and valid
                                                                setCardError(null);
                                                                setIsCardValid(true);
                                                            }
                                                        }}
                                                        onReady={() => {
                                                            console.log('Card component ready');
                                                            setIsCardReady(true);
                                                            setIsCardValid(false); // Reset validity when component is ready
                                                        }}
                                                        onBlur={() => {
                                                            console.log('Card component blurred');
                                                        }}
                                                        onFocus={() => {
                                                            console.log('Card component focused');
                                                        }}
                                                    />
                                                </Box>
                                                {cardError && (
                                                    <Typography color="error" fontSize="12px" mt={1}>
                                                        {cardError}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Box display="flex" justifyContent="end" flexDirection="column">
                                                {!showPromoField ? (
                                                    <>
                                                        {appliedPromo ? (
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    padding: '4px 8px',
                                                                    backgroundColor: '#F0FFF4',
                                                                    borderRadius: '4px',
                                                                    width: 'fit-content',
                                                                    marginLeft: 'auto'
                                                                }}
                                                            >
                                                                <Typography color="#1D9652" fontSize="14px">
                                                                    {appliedPromo.code} applied
                                                                </Typography>
                                                                {/* <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    viewBox="0 0 16 16"
                                                                    fill="none"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        setAppliedPromo(null);
                                                                        setPromoCode('');
                                                                    }}
                                                                >
                                                                    <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                                </svg> */}
                                                            </Box>
                                                        ) : (
                                                            null
                                                            // <Typography
                                                            //     color="#2B2B30"
                                                            //     fontSize="16px"
                                                            //     display="flex"
                                                            //     justifyContent="end"
                                                            //     mb="8px"
                                                            //     sx={{
                                                            //         cursor: 'pointer',
                                                            //         '&:hover': {
                                                            //             textDecoration: 'underline'
                                                            //         }
                                                            //     }}
                                                            //     onClick={() => setShowPromoField(true)}
                                                            // >
                                                            //     Have a promo code?
                                                            // </Typography>
                                                        )}
                                                    </>
                                                ) : (
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="Promo Code:"
                                                        value={promoCode}
                                                        onChange={(e) => {
                                                            setPromoCode(e.target.value);
                                                            setPromoError('');
                                                        }}
                                                        error={!!promoError}
                                                        helperText={promoError}
                                                        sx={{
                                                            width: "100%",
                                                            marginBottom: "25px",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#C7C7C7',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },
                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '14px 16px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        sx={{
                                                                            ".MuiTypography-root": {
                                                                                color: "#333333",
                                                                                fontWeight: "500",
                                                                                fontSize: "16px",
                                                                            },
                                                                            paddingRight: "10px",
                                                                        }}
                                                                    >
                                                                        <Box display="flex" justifyContent="center" alignItems="center">
                                                                            <Box
                                                                                sx={{
                                                                                    background: theme.palette.primary.main,
                                                                                    borderRadius: '4px',
                                                                                    padding: '4px 10px',
                                                                                    marginRight: '4px',
                                                                                    minWidth: '57px',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: '500',
                                                                                    color: '#fff',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={() => validateCoupon()}
                                                                            >
                                                                                Apply
                                                                            </Box>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="17"
                                                                                height="16"
                                                                                viewBox="0 0 17 16"
                                                                                fill="none"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setShowPromoField(false);
                                                                                    setPromoError('');
                                                                                }}
                                                                            >
                                                                                <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                            </svg>
                                                                        </Box>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    ) : null}
                                    <Box sx={{
                                        flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                            width: '100%',
                                        }
                                    }} display="flex" flexDirection="column" justifyContent="space-between">
                                        <Box>
                                            {/* Subdomain field is hidden */}
                                            {false && (
                                                <Box mb="8px">
                                                    <Typography color='#667085' fontSize='15px' marginBottom="8px">Your Custom URL</Typography>
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="https://your-brand.easywebinar.live"
                                                        value={formData.subdomain || ''}
                                                        onChange={(e) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                subdomain: e.target.value.toLowerCase()
                                                            }));
                                                            // Clear error when user starts typing
                                                            setFormErrors(prev => ({
                                                                ...prev,
                                                                subdomain: ''
                                                            }));
                                                        }}
                                                        error={!!formErrors.subdomain}
                                                        helperText={formErrors.subdomain}
                                                        disabled={isAutoRegistering}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#C7C7C7',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },

                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '11px 14px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        sx={{
                                                                            ".MuiTypography-root": {
                                                                                color: "#333333",
                                                                                fontWeight: "500",
                                                                                fontSize: "16px",
                                                                            },

                                                                            paddingRight: "19px",
                                                                        }}
                                                                    >
                                                                        .easywebinar.live
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            {domainSuggestions.length > 0 && (
                                                <Box mt={1} mb={2}>
                                                    <Typography color="primary" fontSize="12px" mb={1}>
                                                        Available alternatives:
                                                    </Typography>
                                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                                        {domainSuggestions.map((suggestion, index) => (
                                                            <Button
                                                                key={index}
                                                                variant="outlined"
                                                                size="small"
                                                                onClick={() => {
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        subdomain: suggestion
                                                                    }));
                                                                    setFormErrors(prev => ({
                                                                        ...prev,
                                                                        subdomain: ''
                                                                    }));
                                                                    setDomainSuggestions([]);
                                                                }}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    borderColor: '#D0D5DD',
                                                                    color: '#344054',
                                                                    padding: '2px 8px',
                                                                    minHeight: '24px',
                                                                    fontSize: '12px',
                                                                    '&:hover': {
                                                                        borderColor: '#667085',
                                                                        backgroundColor: '#F9FAFB'
                                                                    }
                                                                }}
                                                            >
                                                                {suggestion}
                                                            </Button>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            )}
                                            {!planId && <Box borderRadius="8px" bgcolor="#EDF6FF" p="24px 12px" color="#5A5475" >
                                                <Typography variant="body2" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)">URL Guidelines:</Typography>
                                                <Box>
                                                    <Box component="ul" sx={{ "& li": { listStyle: "disc", fontSize: "min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" } }} pl="20px" mt="24px" lineHeight="1.5">
                                                        <Box component="li">
                                                            Use lowercase letters, numbers and hyphens only
                                                        </Box>
                                                        <Box component="li">
                                                            3-30 characters long
                                                        </Box>
                                                        <Box component="li">
                                                            No spaces or special characters
                                                        </Box>
                                                        <Box component="li">
                                                            Cannot start or end with a hyphen
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>}
                                            <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '24px', lg: '24px' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleGetStarted}
                                                    className="x-large-btn"
                                                    disabled={isLoading || isAutoRegistering || (!isTrial && !isCardValid)}
                                                    disableElevation
                                                    fullWidth
                                                    sx={{
                                                        textTransform: "capitalize",
                                                        px: "44px",
                                                        height: "47px!important",
                                                        fontSize: "18px",
                                                        bgcolor: "#0382F7 !important",
                                                        "&:hover": { bgcolor: "#006dd1 !important" },
                                                        "&.Mui-disabled": {
                                                            bgcolor: "#cccccc !important",
                                                            color: "#666666 !important"
                                                        }
                                                    }}
                                                >
                                                    {isLoading || isAutoRegistering ? (
                                                        <CircularProgress size={24} sx={{ color: 'white' }} />
                                                    ) : !isTrial && !isCardValid ? (
                                                        'Please complete card details'
                                                    ) : (
                                                        'Start your subscription'
                                                    )}
                                                </Button>
                                            </Box>
                                            
                                        </Box>
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                mt: 2,
                                                mb: 2
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#374151',
                                                    fontSize: '10px',
                                                    fontWeight: 400,
                                                    lineHeight: 1.5,
                                                    mt: 2,
                                                }}
                                            >
                                                By completing this step, you agree to our <a href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Terms of Service</a> and <a href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit !important", textDecoration: "underline" }}>Privacy Policy</a>
                                                {noTrial ? '' : ' and your 7-day free trial begins.'}
                                            </Typography>
                                        </Box>

                                        {/* G2 Badges Section */}
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                mt: 4,
                                                px: 2,
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#000000',
                                                    fontSize: { xs: '18px', md: '18px', xl: '20px' },
                                                    lineHeight: 1.4,
                                                    mb: 3,
                                                    textAlign: 'center',
                                                    maxWidth: '500px',
                                                    mx: 'auto'
                                                }}
                                            >
                                                Recognized by customers across the world as a leader in multiple categories on G2
                                            </Typography>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                                                    gap: { xs: 2, md: 3 },
                                                    maxWidth: '100%',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <img
                                                    src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png"
                                                    srcSet="
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5.png 1x,
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-2x.png 2x,
                                                        https://easywebinar-site.easywebinar.com/images/autheticator-app-images/g2-badges-group5-3x.png 3x
                                                    "
                                                    alt="G2 Badges - High Performer, Users Love Us, High Performer Asia Pacific, Leader Small Business, Momentum Leader"
                                                    style={{
                                                        maxWidth: '500px',
                                                        height: 'auto',
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                            </Box>
                        </Box >
                    </Box >
                </Box >
            </Box>
            <AccountVerification
                onClose={handleVerificationDialogClose}
                open={verificationDialogOpen}
                onProceed={handleVerificationDialogProceed}
                phoneNumber=""
                email={formData.email}
                password={formData.password}
                companyId={verificationData.companyId}
                companyName={verificationData.companyName}
                infLeadSquaredId={verificationData.infLeadSquaredId}
            />
        </>
    )
}
export default WorkshopBundleLifetime
